import axios from "axios";

export const getStates = callback => {
  var promise = axios({
    method: "get",
    url: "/api/trabajando_states"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
